class DraftService {
  constructor() {
    this.DRAFT_KEY_PREFIX = 'cometchat_draft_';
  }

  getUserConversationKey(userId) {
    return `${this.DRAFT_KEY_PREFIX}user_${userId}`;
  }

  getGroupConversationKey(groupId) {
    return `${this.DRAFT_KEY_PREFIX}group_${groupId}`;
  }

  saveDraftForUser(userId, message) {
    if (!userId || !message.trim()) {
      this.clearDraftForUser(userId);
      return;
    }
    const key = this.getUserConversationKey(userId);
    const oldValue = sessionStorage.getItem(key);
    sessionStorage.setItem(key, message);
    
    // Dispatch custom event for same-tab synchronization
    window.dispatchEvent(new CustomEvent('draftChanged', {
      detail: {
        key,
        newValue: message,
        oldValue
      }
    }));
  }

  saveDraftForGroup(groupId, message) {
    if (!groupId || !message.trim()) {
      this.clearDraftForGroup(groupId);
      return;
    }
    const key = this.getGroupConversationKey(groupId);
    const oldValue = sessionStorage.getItem(key);
    sessionStorage.setItem(key, message);
    
    // Dispatch custom event for same-tab synchronization
    window.dispatchEvent(new CustomEvent('draftChanged', {
      detail: {
        key,
        newValue: message,
        oldValue
      }
    }));
  }

  getDraftForUser(userId) {
    if (!userId) return '';
    const key = this.getUserConversationKey(userId);
    return sessionStorage.getItem(key) || '';
  }

  getDraftForGroup(groupId) {
    if (!groupId) return '';
    const key = this.getGroupConversationKey(groupId);
    return sessionStorage.getItem(key) || '';
  }

  clearDraftForUser(userId) {
    if (!userId) return;
    const key = this.getUserConversationKey(userId);
    const oldValue = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    
    // Dispatch custom event for same-tab synchronization
    window.dispatchEvent(new CustomEvent('draftChanged', {
      detail: {
        key,
        newValue: null,
        oldValue
      }
    }));
  }

  clearDraftForGroup(groupId) {
    if (!groupId) return;
    const key = this.getGroupConversationKey(groupId);
    const oldValue = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    
    // Dispatch custom event for same-tab synchronization
    window.dispatchEvent(new CustomEvent('draftChanged', {
      detail: {
        key,
        newValue: null,
        oldValue
      }
    }));
  }

  clearAllDrafts() {
    const keys = Object.keys(sessionStorage);
    keys.forEach(key => {
      if (key.startsWith(this.DRAFT_KEY_PREFIX)) {
        sessionStorage.removeItem(key);
      }
    });
  }
}

export default new DraftService();